import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Nav from './Nav';
import SideMenu from './SideMenu';

function HeaderTwo() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isSticky, setIsSticky] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    useEffect(() => {
        const handleScroll = () => {
            setIsSticky(window.scrollY > 150);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div>
            <header className={`header-two header--sticky ${isSticky ? 'sticky' : ''}`}>

                {/* ======================= HEADER TOP ======================= */}
                <div className="header-top">
                    <div className="content">
                        <div className="left-header-top">
                            <p className="top-details">
                                Soluções financeiras estruturadas para o seu negócio.
                                <Link to="/Contato">
                                    Fale com um especialista <i className="fal fa-arrow-right" />
                                </Link>
                            </p>
                        </div>

                        <div className="right-header-top">
                            <div className="working-time">
                                <i className="far fa-clock" />
                                <span>Atendimento: Seg a Sex, 08h às 17h</span>
                            </div>

                            <div className="ht-social">
                                <ul>
                                    <li>
                                        <Link to="https://facebook.com" target="_blank">
                                            <i className="fab fa-facebook-f" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://instagram.com" target="_blank">
                                            <i className="fab fa-instagram" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://www.linkedin.com" target="_blank">
                                            <i className="fab fa-linkedin-in" />
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ======================= MAIN HEADER ======================= */}
                <div className="main-header">
                    <div className="content">
                        <div className="header-left">

                            {/* LOGO - Adicionada a barra "/" no src */}
                            <Link className="thumbnail" to="/">
                                <img src="/assets/images/logo/logo-4.svg" alt="GB Partner" />
                            </Link>

                            <Nav />
                        </div>

                        <div className="header-right">
                            <div className="call-area">
                                <div className="icon">
                                    <i className="fas fa-phone-alt" style={{ fontSize: '22px', color: '#0B4DF5' }}></i>
                                </div>

                                <div className="number-area">
                                    <span>WhatsApp Especializado</span>
                                    <Link to="https://wa.me/5571991810262" target="_blank">
                                        <h6 className="call">(71) 99181-0262</h6>
                                    </Link>
                                </div>
                            </div>

                            <Link className="rts-btn btn-primary-2 menu-block-none" to="/Contato">
                                Fale Conosco
                            </Link>

                            {/* BOTÕES DE MENU - Adicionada a barra "/" no src */}
                            <button
                                id="menu-btn"
                                className="menu rts-btn btn-primary-alta ml--20"
                                onClick={toggleSidebar}
                            >
                                <img
                                    className="menu-dark"
                                    src="/assets/images/icon/menu.png"
                                    alt="Menu"
                                />
                                <img
                                    className="menu-light"
                                    src="/assets/images/icon/menu-light.png"
                                    alt="Menu"
                                />
                            </button>
                        </div>
                    </div>
                </div>
            </header>

            <SideMenu isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        </div>
    );
}

export default HeaderTwo;